import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const getGochiEventSettingData = params =>
  axios.get(`${API_HOST}/gochiEvents`, { params, withCredentials: true });

export const getGochiEventSettingDetailData = eventId =>
  axios.get(`${API_HOST}/gochiEvents/${eventId}`, {
    withCredentials: true
  });

export const addGochiEventSettingData = params =>
  axios.post(`${API_HOST}/gochiEvents`, params, { withCredentials: true });

export const editGochiEventSettingData = (eventId, params) =>
  axios.put(`${API_HOST}/gochiEvents/${eventId}`, params, {
    withCredentials: true
  });

export const updateStatusGochiEventSettingData = params =>
  axios.put(`${API_HOST}/gochiEvents/status`, params, {
    withCredentials: true
  });

export const deleteEventSettingData = (eventId, params) =>
  axios.delete(`${API_HOST}/gochiEvents/${eventId}`, params, {
    withCredentials: true
  });

export const getGochiEventSettingDataByMenuId = (menuId, params) =>
  axios.get(`${API_HOST}/menuEvents/${menuId}/gochiEvents`, {
    params,
    withCredentials: true
  });

export const connectGochiEventSettingData = (menuId, params) =>
  axios.put(`${API_HOST}/menuEvents/${menuId}/gochiEvents`, params, {
    withCredentials: true
  });
